import { useMemo } from 'react';
import { ProjectStatus } from '@sib/api';
import { useTranslation } from '@sib/i18n';
import { getProjectStatusColor } from './project-status-styles';

const PROJECT_STATUS_ORDER = Object.values(ProjectStatus);

interface ProjectStatusOption<T> {
  value: T;
  label: string;
  color: string;
}

export const useProjectStatusOptions = <T extends string>() => {
  const { t } = useTranslation();

  return useMemo(
    () =>
      PROJECT_STATUS_ORDER.map(value => ({
        value,
        label: t(`enums.projectStatus.${value}`),
        color: getProjectStatusColor(value),
      })),
    [t]
  ) as ProjectStatusOption<T>[];
};
